(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tms-hero"] && !Shopify.designMode) return;
  try {
    
  function initHeroVideos(root) {
    root.querySelectorAll('[data-hero-video]').forEach(function (hero) {
      if (hero.dataset.heroReady === 'true') return;
      var video = hero.querySelector('video');
      var toggle = hero.querySelector('[data-hero-toggle]');
      if (!video || !toggle) return;
      var preference = window.matchMedia('(prefers-reduced-motion: reduce)');
      var wanted = !preference.matches;
      var manuallyPaused = false;
      var onScreen = true;
      function sync() {
        toggle.textContent = video.paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel;
      }
      function applyPlayback() {
        if (wanted && onScreen && !document.hidden) {
          var playback = video.play();
          if (playback && playback.catch) playback.catch(sync);
        } else {
          video.pause();
        }
        sync();
      }
      toggle.addEventListener('click', function () {
        wanted = video.paused;
        manuallyPaused = !wanted;
        applyPlayback();
      });
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      function updatePreference() {
        if (preference.matches) wanted = false;
        else if (!manuallyPaused) wanted = true;
        applyPlayback();
      }
      if (preference.addEventListener) preference.addEventListener('change', updatePreference);
      else if (preference.addListener) preference.addListener(updatePreference);
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          onScreen = entries[0].isIntersecting;
          applyPlayback();
        }, { threshold: .05 });
        observer.observe(hero);
      }
      document.addEventListener('visibilitychange', applyPlayback);
      hero.dataset.heroReady = 'true';
      video.controls = false;
      video.muted = true;
      toggle.hidden = false;
      applyPlayback();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initHeroVideos(document); });
  } else {
    initHeroVideos(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initHeroVideos(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tms-home-products"] && !Shopify.designMode) return;
  try {
    
  function initHomeProducts(root) {
    root.querySelectorAll('[data-home-products]').forEach(function (section) {
      if (section.dataset.homeReady === 'true') return;
      var tabs = Array.from(section.querySelectorAll('[data-home-tab]'));
      var panels = Array.from(section.querySelectorAll('[data-home-panel]'));
      var tablist = section.querySelector('[data-home-tablist]');
      var fallback = section.querySelector('[data-home-fallback]');
      if (!tablist || !fallback || !tabs.length || !panels.length) return;
      function select(tab) {
        tabs.forEach(function (button) {
          var active = button === tab;
          button.setAttribute('aria-selected', String(active));
          button.tabIndex = active ? 0 : -1;
        });
        panels.forEach(function (panel) { panel.hidden = panel.dataset.homePanel !== tab.dataset.homeTab; });
      }
      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () { select(tab); });
        tab.addEventListener('keydown', function (event) {
          var next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          select(tabs[next]);
          tabs[next].focus();
          tabs[next].scrollIntoView({ block: 'nearest', inline: 'nearest' });
        });
      });
      select(tabs[0]);
      section.dataset.homeReady = 'true';
      tablist.hidden = false;
      fallback.hidden = true;
    });
  }
  initHomeProducts(document);
  document.addEventListener('shopify:section:load', function (event) { initHomeProducts(event.target); });

  } catch(e) { console.error(e); }
})();
})();
